(function(){
  "use strict";

  var prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ---------------------------------------------------------------------
     Mobile nav toggle
     --------------------------------------------------------------------- */
  var navToggle = document.querySelector("[data-nav-toggle]");
  var navMobile = document.querySelector("[data-nav-mobile]");
  if (navToggle && navMobile) {
    navToggle.addEventListener("click", function(){
      var isOpen = navToggle.getAttribute("aria-expanded") === "true";
      navToggle.setAttribute("aria-expanded", String(!isOpen));
      navMobile.classList.toggle("is-open", !isOpen);
      document.body.style.overflow = !isOpen ? "hidden" : "";
    });
    navMobile.querySelectorAll("a").forEach(function(link){
      link.addEventListener("click", function(){
        navToggle.setAttribute("aria-expanded", "false");
        navMobile.classList.remove("is-open");
        document.body.style.overflow = "";
      });
    });
    document.addEventListener("keydown", function(e){
      if (e.key === "Escape" && navMobile.classList.contains("is-open")) {
        navToggle.setAttribute("aria-expanded", "false");
        navMobile.classList.remove("is-open");
        document.body.style.overflow = "";
        navToggle.focus();
      }
    });
  }
/* ------------------------------------------------------------------
   Promo bar dismiss
      ------------------------------------------------------------------ */
      var promoBar = document.querySelector("[data-promo-bar]");
      var promoClose = document.querySelector("[data-promo-close]");
      if (promoBar && promoClose) {
      if (sessionStorage.getItem("promoBarDismissed") === "1") {
      promoBar.classList.add("is-hidden");
      }
      promoClose.addEventListener("click", function(){
      promoBar.classList.add("is-hidden");
      sessionStorage.setItem("promoBarDismissed", "1");
      });
      }

      
  /* ---------------------------------------------------------------------
     Scroll-triggered reveals (IntersectionObserver, transform/opacity only)
     --------------------------------------------------------------------- */
  var revealEls = document.querySelectorAll(".reveal");
  if (revealEls.length) {
    if ("IntersectionObserver" in window) {
      var io = new IntersectionObserver(function(entries){
        entries.forEach(function(entry){
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            io.unobserve(entry.target);
          }
        });
      }, { threshold: 0.15, rootMargin: "0px 0px -8% 0px" });
      revealEls.forEach(function(el){ io.observe(el); });
    } else {
      revealEls.forEach(function(el){ el.classList.add("is-visible"); });
    }
  }

  /* ---------------------------------------------------------------------
     Sticky mobile "Buy Now" CTA bar — appears after scrolling past hero
     --------------------------------------------------------------------- */
  var stickyCta = document.querySelector("[data-sticky-cta]");
  var heroSentinel = document.querySelector("[data-hero-sentinel]");
  if (stickyCta && heroSentinel && "IntersectionObserver" in window) {
    var ctaObserver = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        stickyCta.classList.toggle("is-visible", !entry.isIntersecting && entry.boundingClientRect.top < 0);
      });
    }, { threshold: 0 });
    ctaObserver.observe(heroSentinel);
  }

  /* ---------------------------------------------------------------------
     FAQ accordion
     --------------------------------------------------------------------- */
  document.querySelectorAll("[data-faq-item]").forEach(function(item){
    var q = item.querySelector("[data-faq-q]");
    if (!q) return;
    q.addEventListener("click", function(){
      var willOpen = !item.classList.contains("is-open");
      item.closest("[data-faq-list]").querySelectorAll("[data-faq-item]").forEach(function(other){
        if (other !== item) {
          other.classList.remove("is-open");
          var otherQ = other.querySelector("[data-faq-q]");
          if (otherQ) otherQ.setAttribute("aria-expanded", "false");
        }
      });
      item.classList.toggle("is-open", willOpen);
      q.setAttribute("aria-expanded", String(willOpen));
    });
  });

  // Direct links to a FAQ question reveal its answer using the existing accordion.
  function openLinkedFaq(){
    var id;
    try { id = decodeURIComponent(window.location.hash.slice(1)); } catch(e) { return; }
    if (!id) return;
    var target = document.getElementById(id);
    var item = target && target.closest('[data-faq-item]');
    var question = item && item.querySelector('[data-faq-q]');
    if (question && !item.classList.contains('is-open')) question.click();
  }
  openLinkedFaq();
  window.addEventListener('hashchange', openLinkedFaq);

  /* ---------------------------------------------------------------------
     Product colour selector + gallery (product page)
     Image URLs are resolved via window.WARMBYTE_ASSET_URLS (set by an
     inline script on the Shop page using Shopify's asset_url filter),
     with a same-name fallback for safety.
     --------------------------------------------------------------------- */
  function resolveAsset(filename){
    if (window.WARMBYTE_ASSET_URLS && window.WARMBYTE_ASSET_URLS[filename]) {
      return window.WARMBYTE_ASSET_URLS[filename];
    }
    return filename;
  }

  var GALLERY_SETS = {
    Graphite: [
      { file: "shop-photo-02.jpg", alt: "WarmByte Smart Heating Lunch Box — Graphite, photo 1", label: "Graphite photo 1" },
      { file: "shop-photo-04.jpg", alt: "WarmByte Smart Heating Lunch Box — Graphite, photo 2", label: "Graphite photo 2" },
      { file: "shop-photo-06.jpg", alt: "WarmByte Smart Heating Lunch Box — Graphite, photo 3", label: "Graphite photo 3" },
      { file: "shop-photo-07.jpg", alt: "WarmByte Smart Heating Lunch Box — Graphite, photo 4", label: "Graphite photo 4" },
      { file: "shop-photo-09.jpg", alt: "WarmByte Smart Heating Lunch Box — Graphite, photo 5", label: "Graphite photo 5" },
      { file: "shop-photo-11.jpg", alt: "WarmByte Smart Heating Lunch Box — Graphite, photo 6", label: "Graphite photo 6" }
    ],
    Sandstone: [
      { file: "shop-photo-01.jpg", alt: "WarmByte Smart Heating Lunch Box — Sandstone, photo 1", label: "Sandstone photo 1" },
      { file: "shop-photo-03.jpg", alt: "WarmByte Smart Heating Lunch Box — Sandstone, photo 2", label: "Sandstone photo 2" },
      { file: "shop-photo-05.jpg", alt: "WarmByte Smart Heating Lunch Box — Sandstone, photo 3", label: "Sandstone photo 3" },
      { file: "shop-photo-08.jpg", alt: "WarmByte Smart Heating Lunch Box — Sandstone, photo 4", label: "Sandstone photo 4" },
      { file: "shop-photo-10.jpg", alt: "WarmByte Smart Heating Lunch Box — Sandstone, photo 5", label: "Sandstone photo 5" },
      { file: "shop-photo-12.jpg", alt: "WarmByte Smart Heating Lunch Box — Sandstone, photo 6", label: "Sandstone photo 6" }
    ]
  };

  var colorOptions = document.querySelectorAll("[data-color-option]");
  var colorLabel = document.querySelector("[data-selected-color]");
  var galleryMainImg = document.querySelector("[data-gallery-main]");
  var galleryThumbsWrap = document.querySelector(".gallery-thumbs");

  function renderGallery(colorName){
    var set = GALLERY_SETS[colorName];
    if (!set || !galleryMainImg || !galleryThumbsWrap) return;
    galleryMainImg.src = resolveAsset(set[0].file);
    galleryMainImg.alt = set[0].alt;
    galleryThumbsWrap.innerHTML = "";
    set.forEach(function(item, i){
      var btn = document.createElement("button");
      btn.className = "gallery-thumb" + (i === 0 ? " is-active" : "");
      var resolvedSrc = resolveAsset(item.file);
      btn.setAttribute("data-gallery-src", resolvedSrc);
      btn.setAttribute("data-gallery-alt", item.alt);
      btn.setAttribute("aria-label", item.label);
      var img = document.createElement("img");
      img.src = resolvedSrc;
      img.alt = "";
      img.loading = "lazy";
      btn.appendChild(img);
      galleryThumbsWrap.appendChild(btn);
    });
  }

  if (galleryThumbsWrap) {
    galleryThumbsWrap.addEventListener("click", function(e){
      var thumb = e.target.closest("[data-gallery-src]");
      if (!thumb) return;
      galleryThumbsWrap.querySelectorAll(".gallery-thumb").forEach(function(t){ t.classList.remove("is-active"); });
      thumb.classList.add("is-active");
      if (galleryMainImg) {
        galleryMainImg.src = thumb.getAttribute("data-gallery-src");
        galleryMainImg.alt = thumb.getAttribute("data-gallery-alt");
      }
    });
  }

  if (colorOptions.length) {
    colorOptions.forEach(function(opt){
      opt.addEventListener("click", function(){
        colorOptions.forEach(function(o){
          o.classList.remove("is-selected");
          o.setAttribute("aria-pressed", "false");
        });
        opt.classList.add("is-selected");
        opt.setAttribute("aria-pressed", "true");
        var name = opt.getAttribute("data-color-option");
        if (colorLabel) colorLabel.textContent = name;
        renderGallery(name);
      });
    });
  }

  /* ---------------------------------------------------------------------
     Quantity stepper
     --------------------------------------------------------------------- */
  document.querySelectorAll("[data-qty-stepper]").forEach(function(stepper){
    var input = stepper.querySelector("input");
    var min = parseInt(input.getAttribute("min"), 10) || 1;
    var max = parseInt(input.getAttribute("max"), 10) || 99;
    stepper.querySelectorAll("button").forEach(function(btn){
      btn.addEventListener("click", function(){
        var val = parseInt(input.value, 10) || min;
        val = btn.hasAttribute("data-qty-increase") ? val + 1 : val - 1;
        val = Math.max(min, Math.min(max, val));
        input.value = val;
      });
    });
  });

  /* ---------------------------------------------------------------------
     Form handling: inline validation + focus-management + success state
     --------------------------------------------------------------------- */
  document.querySelectorAll("[data-form]").forEach(function(form){
    form.addEventListener("submit", function(e){
      e.preventDefault();
      var firstInvalid = null;
      var valid = true;

      form.querySelectorAll("[data-field]").forEach(function(field){
        var control = field.querySelector("input, textarea, select");
        if (!control) return;
        var fieldValid = true;
        if (control.hasAttribute("required") && !control.value.trim()) fieldValid = false;
        if (control.type === "email" && control.value.trim() && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(control.value)) fieldValid = false;

        field.classList.toggle("has-error", !fieldValid);
        control.setAttribute("aria-invalid", String(!fieldValid));
        if (!fieldValid) {
          valid = false;
          if (!firstInvalid) firstInvalid = control;
        }
      });

      var status = form.querySelector("[data-form-status]");
      if (!valid) {
        if (firstInvalid) firstInvalid.focus();
        if (status) {
          status.textContent = "Please fix the highlighted fields and try again.";
          status.classList.remove("is-success");
          status.classList.add("is-visible");
        }
        return;
      }

      if (status) {
        status.innerHTML = '<svg width="20" height="20" aria-hidden="true"><use href="#icon-check-circle"></use></svg> Thanks — we’ve received your message and will be in touch shortly.';
        status.classList.add("is-visible", "is-success");
      }
      form.reset();
      form.querySelectorAll("[data-field]").forEach(function(field){
        field.classList.remove("has-error");
      });
    });
  });

})();
